// extracted by mini-css-extract-plugin
export default {"section":"History_section__V5GT+","div":"History_div__7+ycv","h2":"History_h2__9Sl7K","button":"History_button__y2DaZ"};